import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import VueWechatTitle from 'vue-wechat-title';
Vue.config.productionTip = false;
Vue.use(VueWechatTitle);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
console.log(`%cMokYun App Version: 1.0.1`, 'color:#0f0;');
